import React, { useState, useEffect } from 'react';
import Header from '../User/Header';
import Footer from '../User/Footer';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { getAssessmentResult } from '../../services/userassessment';
import verify from "../../assets/images/verify.png";
import loading from "../../assets/images/loader_grey.gif";
import SweetAlert from "react-bootstrap-sweetalert";
import safeHtml from '../../helpers/safeHtml';
import SupportNotice from './SupportNotice';

// The result message is shared with the package report, where the flagged wording ends
// "See the Resource Recommendations section below." That section only exists in the report,
// so on this screen the pointer is reworded to say where the recommendations will be.
// Some messages say "Recommendation section" (singular), so both forms are matched.
const REPORT_POINTER = /See the Resource Recommendations? section below\.?/i;

function forThisScreen(message) {
  if (!message) {
    return message;
  }
  return message.replace(REPORT_POINTER, 'Your report will include resource recommendations.');
}

// A plain numeric id from the address, or null. Anything else is ignored rather than sent on.
function idOrNull(value) {
  return value != null && /^[0-9]+$/.test(String(value)) ? String(value) : null;
}

function UserAssessmentResult() {
  const params = useParams();
  // The quiz puts the package and the finished assessment in the address, so this screen survives
  // a reload and can be opened from a link. Before, it read them only from sessionStorage, where
  // assessmentId is overwritten with the NEXT assessment once the result loads, so a reload asked
  // for the result of an assessment not yet taken. Old addresses without them still work.
  const [searchParams] = useSearchParams();
  const packageFromUrl = idOrNull(searchParams.get('package'));
  const assessmentFromUrl = idOrNull(searchParams.get('assessment'));
  const [assessmentId, setAssessmentId] = useState();
  const [packageId, setPackageId] = useState();
  const [message, setMessage] = useState();
  const [nextAssessmentId, setNextAssessmentId] = useState();
  const [nextSeoName, setNextSeoName] = useState();
  const [alertMsg, setAlertMsg] = useState(false);
  const [coreAssessmentId, setCoreAssessmentId] = useState('0');

  useEffect(() => {
    if (packageFromUrl) {
      sessionStorage.setItem('packageId', packageFromUrl);
    }
    if (assessmentFromUrl) {
      sessionStorage.setItem('assessmentId', assessmentFromUrl);
    }
    if (sessionStorage.getItem('packageId')!=null) {
      setPackageId(sessionStorage.getItem('packageId'));
      if (sessionStorage.getItem('assessmentId')!=null) {
        setAssessmentId(sessionStorage.getItem('assessmentId'));
        getResult();
           }else{
                window.location.href = '/assessments';
           }
         }else{
              window.location.href = '/assessments';
         }
      
  }, []);

  const getResult = async () => {
    if (sessionStorage.getItem('coreAssessmentId')!=null) {
      setCoreAssessmentId(sessionStorage.getItem('coreAssessmentId'));
    }else{
      setCoreAssessmentId('0');
    }
    setAlertMsg(true);
    try {
      const response = await getAssessmentResult(sessionStorage.getItem('assessmentId'),
                            sessionStorage.getItem('packageId'),coreAssessmentId);
      setAlertMsg(false);
      if (response.data.data != null) {
        setNextAssessmentId(response.data.data.nextAssessmentId);
        setMessage(response.data.data.message);
        setNextSeoName(response.data.data.nextSeoName);
        sessionStorage.setItem('assessmentId', response.data.data.nextAssessmentId)
      }else{
        setNextAssessmentId(null);
      }
    } catch (error) {
      setAlertMsg(false);
      console.error(error);
      setNextAssessmentId(null);
    }
  };

  const nextAssessment = async e => {
    e.preventDefault();
    window.location.replace("/assessments/" + nextAssessmentId +"/"+nextSeoName);

  }

  const viewReport = async e => {
    e.preventDefault();
    const reportPackageId = packageFromUrl || sessionStorage.getItem('packageId');
    window.location.replace(reportPackageId ? "/packages/" + encodeURIComponent(reportPackageId) + "/report" : "/packages/report");
  }

  return (
    <>
          <div className="app-main flex-column flex-row-fluid " id="kt_app_main">
            <div className="d-flex flex-column flex-column-fluid">
              <div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">

                <div id="kt_app_toolbar_container" className="app-container  container-xxl d-flex flex-stack ">
                  <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3 ">
                  </div>
                </div>
              </div>

              <div id="kt_app_content" className="app-content  flex-column-fluid " >
                <div id="kt_app_content_container" className="app-container  container-xxl ">
                  <div className="row g-5 g-xl-10 mb-80">
                    <div className="col">
                    {alertMsg ?
                <SweetAlert
        title=""
        timeout={10000}
        showConfirm={false}
        style={{ width: "200px", height: "100px" }}
      > <img src={loading} width="50px" height="50px"/>
      </SweetAlert>
      :<></>}
                      <div className="card card-flush h-md-100">
                        <div className="card-body pt-7">
                          <div className="card-title align-items-start flex-column text-center">
                            <img src={verify} className="h-60px h-lg-75px" />
                            <h1 className="card-label fw-bold text-gray-800 mt-10">Thank You for Completing Assessment.</h1>
                            <h1 className="card-label fw-bold text-gray-800">
                              <div dangerouslySetInnerHTML={safeHtml(forThisScreen(message))}></div></h1>
                          </div>
                          <SupportNotice compact />
                          <div className="col-12 text-center mb-10 mt-10 px-lg-20 px-0">
                            {nextAssessmentId === null ?
                              <button type="submit" className="btn btn-primary col-2" onClick={viewReport}>
                                <span className="indicator-label">View Report</span>
                              </button>
                              :
                              <button type="submit" className="btn btn-primary col-2" onClick={nextAssessment}>
                                <span className="indicator-label">Next Assessment</span>
                              </button>
                            }
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        
    </>
  );
}

export default UserAssessmentResult;